<script>
  import { createEventDispatcher } from 'svelte'

  import { focus } from '../misc.js'

  import authStore from '../auth/store.js'
  import userStore from '../stores/user.js'

  import toastStore from './toast/store.js'

  import PageSub from './page-sub.svelte'


  export let queueId

  let queueName
  const loadQueue = function (user, queueId) {
    if (user !== undefined) {
      queueName = user.queues.find(q => q.queue_id === queueId).name
    }
  }
  $: loadQueue($userStore, queueId)

  const dispatch = createEventDispatcher()

  const back = function () {
    dispatch('back')
  }

  const updateQueue = function () {
    const url = '/api/user/queues/' + queueId
    const data = {
      'name': queueName.trim(),
    }
    return authStore.request({method: 'put', url, data})
      .then(() => toastStore.success('Updated'))
      .catch(e => toastStore.error('Failed to update queue', e))
      .then(() => dispatch('updated'))
  }
</script>

<PageSub title="Rename Queue" on:back={back}>
  <form id="updateQueue" on:submit|preventDefault={updateQueue}>
    <div class="labeledInputWrapper">
      <label for="queueName">Queue Name</label>
      <input id="queueName"
             placeholder="Enter a queue name"
             bind:value={queueName} use:focus
             maxlength="50" required pattern=".*\S.*">
    </div>
  </form>
  <div slot="controls" class="controls">
    <div class="toolbar">
      <span class="spacer"></span>
      <button class="greyButton" type="submit" form="updateQueue">Save</button>
    </div>
  </div>
</PageSub>

<style>
  form {
    flex-grow: 1;

    display: flex;
    flex-direction: column;

    padding: 10px;

    border-top: 1px solid var(--border-color);
    border-bottom: 1px solid var(--border-color);
  }
</style>